import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  VideoPlayer as SatoVideoPlayer,
  VideoPlayerProps,
} from '@sato/components';

export const VideoPlayer = ({ autoPlay, id, ...props }: VideoPlayerProps) => {
  const { hash } = useLocation();

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    // Ignore rejection, e.g. if the browser blocks autoplay
    if (hash.slice(1) === id) videoRef.current?.play().catch(() => {});
  }, [hash]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SatoVideoPlayer
      {...props}
      id={id}
      autoPlay={autoPlay ?? hash.slice(1) === id}
      ref={videoRef}
    />
  );
};
